import React from "react";
import { FieldDef } from "./types";
import { DataMessages, ValidationContext, useData, useDataEvents, useDataValue } from "../hooks/useData";
import { Text } from "./Text";
import { validateFieldDef } from "./validators";
import { Dropdown } from "./Dropdown";
import { Checkbox } from "./Checkbox";
import { EventContext } from "../../data-entry/types";
import { Label } from "./Label";
import { useConditional } from "../hooks/useConditional";
import { Modal } from "../ui/Modal";
import { FormModal } from "../../data-entry/FormModal";
import { Icon } from "../ui/icons";
import { DataEntryCustomScriptFunctions } from "../../data-entry/runScript";

export function AutoForm(props: {
    fields: FieldDef[],
    disabled?: boolean,

	layout?: (get: (name: string) => any) => any,
}) {

    const data = useData();

	// auto validation from field defs
	useDataEvents(data, React.useCallback((msg: any) => {
		if (msg.type !== DataMessages.VALIDATE) return;

		const context = msg.context as ValidationContext<any>;
		for(let def of props.fields) {
			validateFieldDef(context, def);
		}

	}, [props.fields]));


	function createFromDef(def: FieldDef) {
		const options = def.options;

		let controlType = options?.controlType as string;
		
		if (!controlType) {
			// guess
			if (def.prop.startsWith("password")) {
				controlType = "password";
			}
		}

		if (!controlType) controlType = "text";

		let ctl;
		const defaultProps = {
			prop: def.prop,
			title: def.title,
			key: def.prop,
			className: def.className,
			def,
		}
		if (controlType === "text") {
			ctl = <Text {...defaultProps} {...options} key={defaultProps.key} />;

		} else if (controlType === "checkbox") {
			ctl = <Checkbox {...defaultProps} {...options} key={defaultProps.key} />;

		} else if (controlType === "password") {
			ctl = <Text {...defaultProps} key={defaultProps.key} type="password" />;

		} else if (controlType === "dropdown") {
			ctl = 
				<Dropdown {...defaultProps} key={defaultProps.key}
					{...options}
				/>;

		} else if (controlType === "address") {
			ctl = <Address {...defaultProps} key={defaultProps.key} {...options} />;

		}

		return ctl;
	}

	function create(prop: string) {
		for(let def of props.fields) {
			if (def.prop === prop) {
				return createFromDef(def);
			}
		}
	}

	let items;
	if (props.layout) {
		items = props.layout(create);
	} else {
		items = [];
		for(let def of props.fields) {
			const ctl = createFromDef(def);
			items.push(ctl);
		}
	}

    return (
        <>
			{items}
		</>
    )

}

export function Address(props: {
	prop: string,
	title: string,
}) {
	const data = useData();
	let value = useDataValue(data, props.prop);

	const context: EventContext = {
		data,
	} as any;

	let formatted = DataEntryCustomScriptFunctions.formatter(value, 'address/lines+careOf');

	if (!formatted) formatted = <i>Not Entered</i>;

	let label;
	if (props.title) {
		label = 
			<Label
				title={props.title}
			/>;
	}

	let component;
	component = <div style={{whiteSpace:"pre"}}>{formatted}</div>;

	const edit = useConditional((d) => {
		return (
			<FormModal
				title="Edit Address"
				size="width-50pc"

				form="address"

				onCancel={edit.close}

				onSave={(value) => {
					debugger;
					data.setValue(props.prop, value);
					edit.close();
				}}
			/>
		)
	});

	return (
		<div className={"flex group align-center "}>
			{label}
			{component}

			<button
				className="margin-left-10"
				onClick={() => {
					edit.show({});
				}}
			>Change</button>

			{edit.render()}
		</div>
	);
}